










import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import Button from '@/components/utils/Button.vue';
import Title from '@/components/utils/Title.vue';
import ComponentAction from './ComponentActionInterface';

@Component({
  components: {
    Button,
    Title,
  },
})
export default class QueueHome extends Vue {
  title: Object = {
    label: 'Gestion des lignes',
    description: `Cher administrateur, pour gérer vos lignes
    vous avez le choix de choisir de gérer celle-ci soit
    par statut (en attente, validée...) ou alors par choix de l’antenne de votre choix.`,
  };

  @Emit('componentAction')
  goTo(val: string): ComponentAction {
    return {
      info: 'buttonClicked',
      action: 'componentChange',
      actionData: val,
      component: 'QueueHome',
    };
  }
}
